import {
  FooterLinkFields,
  FooterSection,
  FooterSectionFields,
  TCheckboxField,
  TImageField,
  TSocialMediaFields,
  TStringField,
} from '../../../types/types';
import { FooterFields, FooterParams, FooterProps } from '../types/footer.types';

export class FooterModel {
  private readonly fields?: FooterFields;
  private readonly params?: FooterParams;

  constructor(props: FooterProps) {
    this.fields = props?.fields;
    this.params = props?.params;
  }

  private filterSectionByType(list: FooterSection[], type: string): FooterSection[] {
    return list?.filter((item) => item.fields?.sectionType?.fields?.Key?.value === type);
  }

  get footerSections(): FooterSection[] | undefined {
    if (!this.fields?.footerSections) return undefined;
    return this.filterSectionByType(this.fields?.footerSections, 'groupSectionType');
  }

  get navigationSection(): FooterLinkFields | undefined {
    if (!this.fields?.footerSections) return undefined;
    return this.filterSectionByType(this.fields?.footerSections, 'navigationSectionType')?.[0]?.fields?.footerLinks?.[0]?.fields;
  }

  get actionSection(): FooterSectionFields | undefined {
    if (!this.fields?.footerSections) return undefined;
    return this.filterSectionByType(this.fields?.footerSections, 'actionSectionType')?.[0]?.fields;
  }

  get copyrightText(): TStringField | undefined {
    return this.fields?.copyrightText;
  }

  get logoImage(): TImageField | undefined {
    return this.fields?.logoImage;
  }

  get mobileLogoImage(): TImageField | undefined {
    return this.fields?.mobileLogoImage;
  }

  get backToTopText(): TStringField | undefined {
    return this.fields?.backToTopText;
  }

  get hideSocialMedia(): TCheckboxField | undefined {
    return this.params?.hideSocialMedia;
  }

  get socialLinks(): TSocialMediaFields | undefined {
    return this.fields?.socialLinks;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
